import {
  Icons,
  HexIcon,
  Placeholder as StatusMessage,
} from '@cast/design-system';

type NoDataProps = {
  title?: string;
};

export const NoData = ({
  title = 'There are no checks in this organization',
}: NoDataProps) => {
  return (
    <StatusMessage
      icon={
        <HexIcon
          variant="notification"
          icon={<Icons.ShieldSlash weight="fill" />}
          size={64}
        />
      }
      title={title}
      testId="compliance-no-data"
    />
  );
};
